// extracted by mini-css-extract-plugin
module.exports = {"propertyData":"PropertyDataContainer_propertyData__1Feol","breadcrumb":"PropertyDataContainer_breadcrumb__1Am4u","card":"PropertyDataContainer_card__3clH1"};